import { useLazyQuery, useMutation } from "@apollo/client";
import { Box, Button, Pagination, Paper, Stack } from "@mui/material";
import { useAppDispatch } from "hooks/redux";
import Loader from "pages/build-test/loader";
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import NoDataFound from "shared/molecules/no-data";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import SectionTable from "shared/organisms/tables/table";
import entitesClient from "utils/graphql/entitiesClient";
import { DELETE_SUBJECT } from "utils/graphql/services/global-content-hierarchy/mutation";
import {
  GET_COURSES_LIST,
  GET_SUBJECT_LIST,
} from "utils/graphql/services/global-content-hierarchy/queries";
import { table } from "./helper";
import ContentRight from "shared/molecules/content-right";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { makeStyles } from "@mui/styles";
import { indigo } from "@mui/material/colors";
import { SubjectFilter } from "./filter";

const useStyles: any = makeStyles((indigoTheme) => ({
  label: {
    textDecoration: "none",
    textAlign: "center",
    color: indigo[700],
    marginLeft: "80%",
  },
  Btn: {
    backgroundColor: "#3f50b5",
    color: "white",
    width: "90px",
  },
  BtnWrapper: {
    display: "flex",
    gap: "20px",
    justifyContent: "flex-end",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
}));

export default function SubjectsPage() {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [searchPayload, setSearchPayload] = useState({});

  const [clearValuesTrigger, setClearValuesTrigger] = useState(false);

  const [getSubjectList, { loading, error, data }] = useLazyQuery(
    GET_SUBJECT_LIST,
    {
      client: entitesClient,
    }
  );

  const handleChange = (event, value) => {
    setPage(value); 
  };

  const handlePreview = (objectId,status) => {
    history.push(`/global-content-hierarchy/subjects/update?id=${objectId}&status=${status}`);
  };

  useEffect(() => {
    getSubjectList({ variables: { filter: {...searchPayload, page: page, limit } } });
  }, [searchPayload,page, limit]);

  return (
    <>
      <ContentRight>
        <Link to="subjects/create" className={classes.label}>
          <Button variant="contained"> Create Subject</Button>
        </Link>
      </ContentRight>
      <TypographyHeading sx={{ mb: 2, mt: 3, fontSize: "25px" }}>
        Subjects{" "}
      </TypographyHeading>
      <SubjectFilter
        setSearchPayload={setSearchPayload}
        setPage={setPage}
        clearValuesTrigger={clearValuesTrigger}
      />
      <Paper elevation={2} sx={{ px: 2, pb: 4, pt: 2, mt: 2 }}>
        <div>
          {loading && <Loader />}
          {!loading && data?.getSubjects?.records?.length > 0 ? (
            <SectionTable
              data={data?.getSubjects?.records}
              table={table}
              id="id"
              name="id"
              handlePreview={handlePreview}
              rowsPerPageCount={10}
              style="false"
              totalRecords={data?.getSubjects?.meta?.total || 0}
              paginationSegment="false"
              viewSecondaryData="false"
            />
          ) : (
            <div>{!loading && <NoDataFound message="No Data" />}</div>
          )}
        </div>
        <Box sx={{ marginTop: "20px" }}>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Pagination
              count={Math.ceil(data?.getSubjects?.meta?.total / limit) || 1}
              page={page}
              onChange={handleChange}
              color="primary"
              size="medium"
            />
          </Stack>
        </Box>
      </Paper>
    </>
  );
}
